/*
 * @Author: 陈朝晖
 * @Date: 2024-08-19 14:53:32
 * @LastEditTime: 2024-12-16 09:25:15
 * @Description:
 */
let sjzlHost = location.host.includes("erp.fjdaze.com")
  ? "https://sjzl.fjdaze.com"
  : "http://test.fjdaze.com";
let erpHost = location.host.includes("erp.fjdaze.com")
  ? "https://erppc.fjdaze.com"
  : "https://test.fjdaze.com";
export default {
  defaultImg: "http://oss.fjdaze.com/aliProject/images/no_image100x100.jpg",
  //登录occ地址
  loginbaseUrl: "https://occ.fjdaze.com",
  //图片的地址
  imgUrl:
    process.env.NODE_ENV === "development"
      ? "https://test-oss.fjdaze.com/"
      : location.host.indexOf("127.0.0.1") > -1 ||
        location.host.indexOf("192.168.0") > -1 ||
        location.host.indexOf("erp.fjdaze.cn") > -1
      ? "https://test-oss.fjdaze.com/"
      : "https://oss.fjdaze.com/",
  imgUrl2: "https://oss.fjdaze.com/tools/",
  alicdn: "https://cbu01.alicdn.com/",
  //视频下载地址
  downloadFun: function (params) {
    var downloadUrl = "";
    if (process.env.NODE_ENV === "development") {
      downloadUrl = "http://192.168.0.17:8012/test/";
    } else {
      if (location.host.indexOf("127.0.0.1") > -1) {
        downloadUrl = "http://192.168.0.17:8012/test/";
      } else if (location.host.indexOf("192.168.0") > -1) {
        downloadUrl = "http://192.168.0.17:8012/";
      } else if (location.host.indexOf("test.fjdaze.com") > -1) {
        downloadUrl = "https://test-api.fjdaze.com/";
      } else {
        downloadUrl = "https://api.fjdaze.com/";
      }
    }
    return downloadUrl;
  },
  // dzzxHost: process.env.NODE_ENV === 'development' ? 'http://192.168.0.216:8080/#/' : '/static/dzxx/index.html#/',
  dzzxHost: sjzlHost + "/static/dzxx/index.html#/",
  pictureUpload:
    process.env.NODE_ENV === "development"
      ? "http://192.168.0.17:8012/test/"
      : "https://api.fjdaze.com/",
  aliAlbumHost: "https://cbu01.alicdn.com/",
  DOMAIN: sjzlHost,
  DOMAINHttp: sjzlHost,
  IFRAME_HOST: erpHost,
};
